/** Direct EGP amount (e.g. 12.5) -> display string, e.g. "12.50 EGP". */
export function formatEgp(amountEgp: number): string {
  return `${amountEgp.toFixed(2)} EGP`;
}

/** EGP text input (e.g. "50", "50.5") -> a validated number, or null if invalid/negative/too precise. */
export function parseEgpInput(input: string): number | null {
  const trimmed = input.trim();
  if (!trimmed || !/^\d+(\.\d{1,2})?$/.test(trimmed)) return null;
  return parseFloat(trimmed);
}
